export default class Accordion {
    constructor(selector, options = {}) {
        this.container = document.querySelector(selector);
        if (!this.container) return;

        this.items = this.container.querySelectorAll(".collapse-item");

        this.settings = {
            singleOpen: true,
            scrollToOpen: false,
            ...options
        };

        this.init();
    }

    init() {
        this.items.forEach(item => {
            const button = item.querySelector(".btn-collapse");
            const content = item.querySelector(".collapse");

            if (!button || !content) return;

            button.addEventListener("click", () => {
                this.toggle(item, content);
            });
        });
    }

    toggle(item, content) {
        const isOpen = item.classList.contains("active");

        if (this.settings.singleOpen) {
            this.closeAll();
        }

        if (!isOpen) {
            this.open(item, content);
        }
    }

    open(item, content) {
        item.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";

        if (this.settings.scrollToOpen) {
            item.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    }

    close(item) {
        const content = item.querySelector(".collapse");
        item.classList.remove("active");
        if (content) content.style.maxHeight = null;
    }

    closeAll() {
        this.items.forEach(item => this.close(item));
    }
}
